import type {
    IAcceptanceResponse,
    IRecordAcceptance,
    IRequiredAcceptanceResponse,
    TAcceptanceScope,
} from '@escloud/types';

import type { ApiClient } from './api-client';

import { getApiUrlForRegion } from '@/lib/region-config';

/** Legal document acceptance endpoints (ESCLOUD-79 / ESCLOUD-157). */
export class LegalService {
    constructor(private api: ApiClient) {}

    /**
     * Document versions the current user must (re)accept. The scope picks the
     * gate: `eula` (the server default) for the pre-payment gate, `device_use`
     * for the attestation + IFU gate deferred to first clinical use
     * (ESCLOUD-287). `region` targets a specific regional API: the funnel has
     * no tenant in context yet, so it names the intent's region explicitly.
     */
    getRequiredAcceptances(
        scope?: TAcceptanceScope,
        region?: string
    ): Promise<IRequiredAcceptanceResponse[]> {
        return this.api.get(
            scope ? `/legal/required-acceptances?scope=${scope}` : '/legal/required-acceptances',
            region ? { baseUrl: getApiUrlForRegion(region) } : undefined
        );
    }

    /** Records one acceptance decision for the current user, in `region` when given. */
    recordAcceptance(data: IRecordAcceptance, region?: string): Promise<IAcceptanceResponse> {
        return this.api.post(
            '/legal/acceptances',
            data,
            region ? { baseUrl: getApiUrlForRegion(region) } : undefined
        );
    }

    /** The current user's full acceptance history (Past EULA versions dialog). */
    getMyAcceptances(): Promise<IAcceptanceResponse[]> {
        return this.api.get('/legal/acceptances/me');
    }
}
